angular.module 'zc.core'

.factory 'errorInterceptor', ($location, $q, $injector, $translate, returnUrl) ->

  _createBetterErrorsModal = (res) ->
    Environment = $injector.get 'Environment'
    Environment.get()
    .then (environment) ->
      return unless environment == 'development'
      if $("#better-errors-modal").length == 0
        betterErrors = """
          <div class="modal fade" id="better-errors-modal" tabindex="-1" role="dialog">
            <div class="modal-dialog" style="width: 80%" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                  <h4 class="modal-title">500 Error</h4>
                </div>
                <div class="modal-body">
                  <iframe src="" style="width: 100%; height: 60vh"></iframe>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                </div>
              </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->
          </div><!-- /.modal -->"""
        $("body").append(betterErrors)
      else
        # Make sure the page is reloaded when there are more errors
        $('#better-errors-modal .modal-body iframe').attr("src", "")

      # Make the content src load only after the animation has appeared.
      # Otherwise the animation will freeze in the middle and it's kimochiwarui
      $('#better-errors-modal').on 'shown.bs.modal', () ->
        $('#better-errors-modal .modal-body iframe').attr("src", "#{ZC_CONFIG.RAILS_API_URL}:#{ZC_CONFIG.RAILS_API_PORT}/__better_errors")

      # Actually show the modal
      $('#better-errors-modal').modal()


  # There might be many many errors at once, so debounce it to give some
  # protection
  createBetterErrorsModal = _.debounce(_createBetterErrorsModal, 500)

  success = (res) ->
    # TODO: Move to directives
    alertify.success res.data.message if res.data?.message
    res

  translateErrorKeyName = (res, keyName) ->
    # this is old behavior; keep compatibility...
    translatedKeyName = $translate.instant(keyName)
    if translatedKeyName != keyName
      translatedKeyName
    else
      # XXX qualify translation key from api path in somewhat ad-hoc way...
      anchorElement = document.createElement('a')
      anchorElement.href = res.config.url
      apiPath = anchorElement.pathname
      return keyName unless apiPath

      apiPath = _(apiPath.replace(/\d+/g, '').replace('//', '/').split('/')).
        compact().
        join(".")
      qualifiedKeyName = "#{apiPath}.#{keyName}"

      $translate.instant(qualifiedKeyName)

  error = (res) ->
    # TODO: Move to directives
    alertify.error res.data.error_message, 0 if res?.data?.error_message

    $state = $injector.get '$state'
    switch res.status
      when 401
        # XXX For unknown reason (timing issue?), $state.current isn't
        # initialized correctly sometimes...
        # In that case, $state.current is initialized like this:
        #
        #   Object {name: "", url: "^", views: null, abstract: true}
        #
        # , which ideally should be like this:
        #
        #   Object {url: "/sign_in", views: Object, name: "users.signIn"}
        #
        # For the moment, work around by ensuring $state.current.name
        # isn't empty.
        #
        # Investigate this issue!
        if $state.current.name.length > 0 and
           $state.current.name.indexOf('users') isnt 0
          Devise = $injector.get 'Devise'
          Devise.signOut()
      when 406
        if $state.current.name.indexOf('users') isnt 0
          if $location.path() != $state.href('users.signIn', {})
            returnUrl.set($location.url())
          $state.transitionTo 'users.signIn'
      when 404
        $state.go '404', null,
          location: false
      when 422
        _.each res.data.errors, (errors, key) ->
          _.each errors, (error) ->
            alertify.error "#{translateErrorKeyName(res, key)}#{error}", 0
      when 500
        alertify.error "500 Error: #{res.data.error}", 0

        if res.data?.show_better_errors
          createBetterErrorsModal(res)

    $q.reject res

  return {
    response: success
    responseError: error
  }



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/interceptors/error_interceptor.js.coffee